import flatMap from 'lodash/flatMap'
import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';

import * as React from 'react';
import isEqual from 'react-fast-compare';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat, SeatZone } from '../../classes/seat';


declare var Modernizr: any;

interface ISeatGroupPathProps {
    key: string;
    seats: Array<Seat>;
    cartSeats: Array<CartSeat>;
    selectedSeats: Array<Seat>;
    dispatch: any;
    levelPricing: Array<SeatZone>;
    selectedPriceTypes: Array<PriceType>;
    lowerPrice: number;
    upperPrice: number;
    isExchange: boolean;
    mouseOverGroup: (Seat, xPos, yPos) => any;
    mouseOutGroup: (Seat) => any;
    mapDragging: boolean;
}

enum SeatHoverPosition {
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight
}

class SeatGroupPath extends React.Component<ISeatGroupPathProps, { hovered: boolean }>{
    private selectedPrices: Array<any> = [];
    private hasHoverText: boolean = false;

    constructor(props) {
        super(props);
        this.state = {
            hovered: false
        };

        let seatZoneIds = uniq(props.seats.map(seat => {
            return parseInt(seat.tessituraSeat.zoneId);
        }));

        let matchedZones = props.levelPricing.filter(levelPricing => seatZoneIds.some(zoneId => levelPricing.zoneId === zoneId));

        if (matchedZones && matchedZones.length > 0) {
            let prices = flatMap(matchedZones, zone => zone.prices);
            this.selectedPrices = prices.filter(price => props.selectedPriceTypes.some(selectedPriceType => selectedPriceType.priceTypeId === parseInt(price.priceTypeId)));

            //this means the user did not pick any filters, so no need to match on selected filters
            if (props.selectedPriceTypes.length === 0) {
                this.selectedPrices = prices;
            }
        }

        this.hasHoverText = props.seats[0].seatStyleCulture.smallPrompt !== null && props.seats[0].seatStyleCulture.smallPrompt.length > 0;

    }

    shouldComponentUpdate(nextProps: ISeatGroupPathProps, nextState) {
        return !isEqual(this.props, nextProps) || this.state.hovered !== nextState.hovered;
    }

    private isInPriceRange(): boolean {

        if (this.selectedPrices.length > 0) {
            return this.selectedPrices.some(price => price.price >= this.props.lowerPrice && price.price <= this.props.upperPrice);

        } else {
            return false;
        }
    }

    render() {
        var selectedSeat = this.props.selectedSeats.some(seat => this.props.seats.map(s => s.seatId).some(seatId => seatId === seat.seatId));
        let cartSeats = this.props.cartSeats.filter(cartSeat => this.props.seats.some(seat => seat.seatId === cartSeat.seatId));
        let inCart = cartSeats.length > 0;

        let firstAvailableSeat = orderBy(this.props.seats, (seat: Seat) => { return seat.tessituraSeat.isAvailable; }, 'desc')[0];

        var seatFill = inCart ? (selectedSeat ? cartSeats[0].seatStyle.svgSelectedFill : cartSeats[0].seatStyle.svgDefaultFill) : (selectedSeat ? this.props.seats[0].seatStyle.svgSelectedFill : this.props.seats[0].seatStyle.svgDefaultFill);
        seatFill = this.state.hovered && this.props.seats[0].tessituraSeat.isAvailable && !Modernizr.touchevents ? this.props.seats[0].seatStyle.svgHoverFill : seatFill;

        return (
            <path id={'seat-' + this.props.seats[0].seatId} data-seat-id={this.props.seats.map(seat => seat.seatId).join()}
                key={this.props.seats[0].seatId} d={this.props.seats[0].svgPath} fill={seatFill}
                strokeWidth={this.props.seats[0].seatStyle.svgStrokeWidth}
                stroke={this.props.seats[0].seatStyle.svgStrokeColor}
                className={(!this.props.seats[0].tessituraSeat.isAvailable ? " is-unavailable" : "") + (((!this.props.isExchange) && (!selectedSeat && !this.props.seats[0].suggestedSeat) || !this.isInPriceRange())
                    && this.props.seats[0].tessituraSeat.isAvailable ? " criteria-mismatch" : "")
                    + (this.hasHoverText ? " has-hover" : "") + " seat-group-path-js seat-path"}
                onMouseOver={(e) => {
                    this.setState({ ...this.state, hovered: true });
                    if (!this.props.mapDragging) {
                        var pathRect = (e.target as any).getBoundingClientRect();

                        this.props.mouseOverGroup(this.props.seats, pathRect.left + (pathRect.width / 2), pathRect.top + (pathRect.height / 2));
                    }
                }}
                onMouseOut={(e) => {
                    this.setState({ ...this.state, hovered: false });
                    var hoverElement = document.getElementsByClassName('hover-map-svg');

                    var inX = false;
                    var inY = false;
                    if (hoverElement.length > 0) {
                        var hoverRect = hoverElement[0].getBoundingClientRect()
                        inX = hoverRect.left <= e.clientX && e.clientX <= hoverRect.right;
                        inY = hoverRect.top <= e.clientY && e.clientY <= hoverRect.bottom;
                    }

                    if (!this.props.mapDragging && !(inX && inY)) {
                        this.props.mouseOutGroup(this.props.seats);
                    }
                }} />
        );
    }
}

export default SeatGroupPath;